import { useEffect, useState } from 'react'

import { useLead, useProposal } from '@itau-loans-www/hooks'
import { http, sdkAnalytics } from '@itau-loans-www/services'
import { isClient, storage, getProduct } from '@itau-loans-www/utils'

const useFgtsSuccess = () => {
  const [isClicked, setIsClicked] = useState(true)
  const [isButtonLoading, setButtonLoading] = useState(false)
  const proposalContext = useProposal()
  const productCode = proposalContext?.product?.proposal?.productCode

  const simulationOptionUuid =
    (isClient() && storage.session.getItem('simulationOptionUuid')) ?? ''

  const handleAuthorizeContact = () => {
    setButtonLoading(true)

    http.proposal
      .finishFGTSProposal('whatsapp', simulationOptionUuid, productCode)
      .then(() => setIsClicked(true))
      .catch(() => setButtonLoading(false))
  }

  return { isButtonLoading, isClicked, handleAuthorizeContact }
}

const useTracking = (isClicked) => {
  const {
    leadData: { tracking: { isFromAllowFGTSAppStep } = {} }
  } = useLead()

  const proposalContext = useProposal()

  useEffect(() => {
    if (isFromAllowFGTSAppStep) {
      sdkAnalytics.track('trackScreenView', 'AllowFgtsAppNotSuccess')
    }

    const product = getProduct()

    const monetaryValue = proposalContext?.product?.proposal?.requestedLoanValue

    if(product === 'fgts' && monetaryValue && isClicked) {
      sdkAnalytics.track('trackEvent', {
        event_name: 'proposal',
        parameters: {
          proposal_id: 'nao-aplicavel',
          custom_path: '/fgts/saque-aniversario/oferta/nao-correntista/sucesso',
          "monetary_value": proposalContext?.product?.proposal?.requestedLoanValue
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export { useFgtsSuccess, useTracking }
